(() => {
  if (window.msCarbonRecommendationReady) return;
  window.msCarbonRecommendationReady = true;

  const modal = document.querySelector('[data-ms-carbon-modal]');
  if (!modal) return;

  const dialog = modal.querySelector('.ms-carbon-modal__dialog');
  const cards = [...modal.querySelectorAll('[data-ms-care-card]')];
  const status = modal.querySelector('[data-ms-carbon-status]');
  let lastTrigger;
  let cartNotificationHome;
  let cartNotificationNext;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const isCartNotificationOpen = () => document.body.classList.contains('ms-cart-notification-open') || !!document.querySelector('cart-notification .cart-notification.active');

  const elevateCartNotification = () => {
    const cartNotification = document.querySelector('cart-notification');
    if (!cartNotification) return;

    if (!cartNotificationHome) {
      cartNotificationHome = cartNotification.parentNode;
      cartNotificationNext = cartNotification.nextSibling;
    }

    document.body.appendChild(cartNotification);
    cartNotification.classList.add('ms-cart-notification-elevated');
  };

  const clearCartNotificationInlineState = (cartNotification) => {
    const panel = cartNotification?.querySelector('.cart-notification');
    cartNotification?.style.removeProperty('display');
    cartNotification?.style.removeProperty('visibility');
    cartNotification?.style.removeProperty('opacity');
    cartNotification?.style.removeProperty('pointer-events');
    panel?.style.removeProperty('display');
    panel?.style.removeProperty('visibility');
    panel?.style.removeProperty('opacity');
    panel?.style.removeProperty('pointer-events');
    panel?.style.removeProperty('transform');
  };
  const restoreCartNotification = () => {
    const cartNotification = document.querySelector('cart-notification.ms-cart-notification-elevated');
    if (!cartNotification || !cartNotificationHome) return;

    cartNotification.classList.remove('ms-cart-notification-elevated');
    cartNotificationHome.insertBefore(cartNotification, cartNotificationNext);
    cartNotificationHome = null;
    cartNotificationNext = null;
  };

  const markCartNotificationOpen = () => {
    elevateCartNotification();
    const cartNotification = document.querySelector('cart-notification.ms-cart-notification-elevated');
    const panel = cartNotification?.querySelector('.cart-notification');
    document.body.classList.add('ms-cart-notification-open');
    if (cartNotification) {
      cartNotification.style.display = 'block';
      cartNotification.style.visibility = 'visible';
      cartNotification.style.opacity = '1';
      cartNotification.style.pointerEvents = 'auto';
    }
    if (panel) {
      panel.classList.add('animate', 'active');
      panel.style.visibility = 'visible';
      panel.style.opacity = '1';
      panel.style.pointerEvents = 'auto';
    }
  };

  const renderCartNotificationSafely = (cartUi, result) => {
    if (!cartUi || !result?.sections || typeof cartUi.renderContents !== 'function') return;

    try {
      cartUi.renderContents(result);
    } catch (error) {
      // The item was added; still show the confirmation if a section render fails.
      markCartNotificationOpen();
    }
  };

  const closeCareModalOnly = () => {
    modal.hidden = true;
    document.body.classList.remove('ms-carbon-modal-open', 'ms-carbon-cart-action-hover');
  };

  const productUrl = (handle) => {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}products/${encodeURIComponent(handle)}.js`;
  };


  const setCardProduct = (card, product) => {
    const variant = product?.variants?.find((item) => item.available) || product?.variants?.[0];
    if (!variant) return false;

    card.dataset.careVariantId = String(variant.id);
    const title = card.querySelector('[data-ms-care-title]');
    const price = card.querySelector('[data-ms-care-price]');
    const button = card.querySelector('[data-ms-care-add]');
    if (title && product.title) title.textContent = product.title;
    if (price && variant.price != null) {
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }).format(Number(variant.price) / 100);
    }
    card.dataset.careUnavailable = variant.available ? 'false' : 'true';
    if (button) button.disabled = !variant.available;
    return true;
  };

  const fetchProduct = async (url) => {
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return response.json();
  };

  const findCardProduct = async (card) => {
    if (card.dataset.careVariantId) return card.dataset.careUnavailable !== 'true';

    try {
      const product = await fetchProduct(productUrl(card.dataset.careHandle));
      if (product && setCardProduct(card, product)) return card.dataset.careUnavailable !== 'true';
    } catch (error) {
      // Continue with predictive search.
    }

    try {
      const query = encodeURIComponent(card.dataset.careQuery);
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root.replace(/\/?$/, '/')}search/suggest.json?q=${query}&resources[type]=product&resources[limit]=6`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return false;

      const data = await response.json();
      const products = data.resources?.results?.products || [];
      const reference = card.dataset.careReference.toLowerCase();
      const queryTerms = card.dataset.careQuery.toLowerCase().split(' ');
      const match =
        products.find((product) => {
          const searchable = `${product.title} ${product.handle || ''} ${product.url || ''}`.toLowerCase();
          return searchable.includes(reference);
        }) ||
        products.find((product) => {
          const searchable = `${product.title} ${product.handle || ''} ${product.url || ''}`.toLowerCase();
          return queryTerms.every((term) => searchable.includes(term));
        });
      if (!match?.url) return false;

      const productUrl = match.url.split('?')[0];
      const product = await fetchProduct(`${productUrl}.js`);
      return product ? setCardProduct(card, product) && card.dataset.careUnavailable !== 'true' : false;
    } catch (error) {
      return !!card.dataset.careVariantId && card.dataset.careUnavailable !== 'true';
    }
  };

  const prepareProducts = async () => {
    await Promise.all(
      cards.map(async (card) => {
        if (!card.dataset.careVariantId) await findCardProduct(card);
        const button = card.querySelector('[data-ms-care-add]');
        if (button) button.disabled = !card.dataset.careVariantId || card.dataset.careUnavailable === 'true';
      })
    );
  };

  const openModal = async (trigger) => {
    lastTrigger = trigger || document.activeElement;
    modal.hidden = false;
    document.body.classList.add('ms-carbon-modal-open');
    document.body.classList.remove('ms-carbon-cart-after-care');
    elevateCartNotification();
    window.setTimeout(elevateCartNotification, 80);
    window.setTimeout(elevateCartNotification, 260);
    dialog.focus();
    await prepareProducts();
  };

  const closeModal = () => {
    closeCareModalOnly();

    const cartNotification = document.querySelector('cart-notification');
    const panel = cartNotification?.querySelector('.cart-notification');
    const shouldRevealCartNotification = isCartNotificationOpen() || panel?.classList.contains('active');

    if (shouldRevealCartNotification) {
      markCartNotificationOpen();
      document.body.classList.add('ms-carbon-cart-after-care');
      return;
    }

    document.body.classList.remove('ms-carbon-cart-after-care');
    restoreCartNotification();
    if (lastTrigger?.focus) lastTrigger.focus();
  };
  const addCareProduct = async (button) => {
    const card = button.closest('[data-ms-care-card]');
    const label = button.querySelector('[data-ms-care-add-label]');
    if (!card || button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');
    status.textContent = '';

    try {
      if (!card.dataset.careVariantId) {
        label.textContent = 'A localizar...';
        const productFound = await findCardProduct(card);
        if (!productFound || !card.dataset.careVariantId) {
          throw new Error('Produto não localizado. Consulte todos os produtos de tratamento.');
        }
        button.disabled = true;
      }

      const variantId = card.dataset.careVariantId;
      const cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cartUi) {
        formData.append(
          'sections',
          cartUi
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Não foi possível adicionar este produto.');
      }

      renderCartNotificationSafely(cartUi, result);
      markCartNotificationOpen();
      label.textContent = 'Adicionado';
      status.textContent = 'Produto adicionado ao carrinho.';
      window.setTimeout(() => {
        if (card.dataset.careUnavailable !== 'true') label.textContent = 'Adicionar';
      }, 1600);
    } catch (error) {
      status.textContent = error.message || 'Não foi possível adicionar. Tente novamente.';
      label.textContent = 'Adicionar';
      button.disabled = false;
    } finally {
      button.classList.remove('is-loading');
      button.disabled = !card.dataset.careVariantId || card.dataset.careUnavailable === 'true';
    }
  };

  const addVariantDirectly = async (button) => {
    const variantId = button?.dataset.variantId;
    if (!variantId || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'A adicionar...';

    try {
      const cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cartUi) {
        formData.append(
          'sections',
          cartUi
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
        if (cartUi.setActiveElement) cartUi.setActiveElement(button);
      }

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Nao foi possivel adicionar este produto.');
      }

      renderCartNotificationSafely(cartUi, result);
      markCartNotificationOpen();
      button.textContent = 'Adicionado';
      window.setTimeout(() => {
        button.textContent = originalText;
      }, 1600);
    } catch (error) {
      button.textContent = error.message || 'Tente novamente';
      window.setTimeout(() => {
        button.textContent = originalText;
      }, 2200);
    } finally {
      button.disabled = false;
    }
  };

  const pointInside = (event, element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('[data-ms-carbon-modal], [data-ms-carbon-close], [data-ms-care-continue]')) return;
      if (!document.body.classList.contains('ms-carbon-cart-after-care')) return;
      if (modal.hidden && !isCartNotificationOpen()) return;
      const cartNotification = document.querySelector('cart-notification.ms-cart-notification-elevated');
      if (!cartNotification || !pointInside(event, cartNotification)) return;

      const cartLink = cartNotification.querySelector('#cart-notification-button[href]');
      if (pointInside(event, cartLink)) {
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('ms-carbon-cart-after-care');
        closeCareModalOnly();
        window.location.assign(cartLink.href);
        return;
      }

      const checkoutButton = cartNotification.querySelector('#cart-notification-form button[name="checkout"]');
      if (pointInside(event, checkoutButton)) {
        const form = checkoutButton.closest('form');
        if (!form) return;
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('ms-carbon-cart-after-care');
        closeCareModalOnly();
        form.submit();
        return;
      }

      const closeButton = cartNotification.querySelector('.cart-notification__close');
      if (pointInside(event, closeButton)) {
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('ms-carbon-cart-after-care');
        cartNotification.close?.();
        clearCartNotificationInlineState(cartNotification);
        restoreCartNotification();
        if (lastTrigger?.focus) lastTrigger.focus();
        return;
      }

      const continueButton = cartNotification.querySelector('.cart-notification__continue[href]');
      if (pointInside(event, continueButton)) {
        event.preventDefault();
        event.stopPropagation();
        document.body.classList.remove('ms-carbon-cart-after-care');
        closeCareModalOnly();
        window.location.assign(continueButton.href);
      }
    },
    true
  );

  document.addEventListener('mousemove', (event) => {
    if (modal.hidden && !document.body.classList.contains('ms-carbon-cart-after-care') && !isCartNotificationOpen()) return;
    const cartNotification = document.querySelector('cart-notification.ms-cart-notification-elevated');
    const cartLink = cartNotification?.querySelector('#cart-notification-button[href]');
    const checkoutButton = cartNotification?.querySelector('#cart-notification-form button[name="checkout"]');
    const closeButton = cartNotification?.querySelector('.cart-notification__close');
    const continueButton = cartNotification?.querySelector('.cart-notification__continue');
    const isClickable =
      pointInside(event, cartLink) ||
      pointInside(event, checkoutButton) ||
      pointInside(event, closeButton) ||
      pointInside(event, continueButton);
    document.body.classList.toggle('ms-carbon-cart-action-hover', isClickable);
  });

  document.addEventListener('mouseleave', () => {
    document.body.classList.remove('ms-carbon-cart-action-hover');
  });

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ms-carbon-open]');
    const closeButton = event.target.closest('[data-ms-carbon-close]');
    const addButton = event.target.closest('[data-ms-care-add]');
    const inlineAddButton = event.target.closest('[data-ms-carbon-inline-add]');
    const continueButton = event.target.closest('[data-ms-care-continue]');

    if (openButton) {
      event.preventDefault();
      openModal(openButton);
    }

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
      return;
    }

    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addCareProduct(addButton);
      return;
    }

    if (inlineAddButton) {
      event.preventDefault();
      addVariantDirectly(inlineAddButton);
    }

    if (continueButton) {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
      return;
    }
  });

  document.addEventListener('ms:footwear-added', (event) => {
    if (event.detail?.eligible) openModal(event.detail.trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  window.addEventListener('pageshow', (event) => {
    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    const isHistoryRestore = event.persisted || navigation?.type === 'back_forward';
    if (!isHistoryRestore) return;

    modal.hidden = true;
    document.body.classList.remove('ms-carbon-modal-open', 'ms-carbon-cart-after-care', 'ms-carbon-cart-action-hover');
    const cartNotification = document.querySelector('cart-notification');
    cartNotification?.close?.();
    restoreCartNotification();
  });

  prepareProducts();
})();
